






































import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Company } from '@/modules/backend/Entities/Company';
import { EditCompanyData } from '@/modules/backend/Dto/EditCompanyData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { CompaniesModule } from '@/store/dashboard/companies/CompaniesModule';
import { resolveModule } from '@/store';
import { ValidationObserver } from '@/plugins/vee-validate';

const ResourcesModule = namespace('dashboard/resources');

interface CompanyForm {
  name: string;
  email: string;
}

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class CompanyEditingDialog extends Mixins(Mixin) {
  private readonly companiesModule: CompaniesModule = resolveModule(CompaniesModule);

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @Prop({ required: true })
  private company!: Company;

  @ResourcesModule.Action('Fetch')
  private readonly fetchResources!: () => Promise<void>;

  private form: CompanyForm = {
    name: this.company.getName(),
    email: this.company.getEmail(),
  };

  private clearForm(): void {
    this.observer.reset();
    this.form.name = this.company.getName();
    this.form.email = this.company.getEmail();
  }

  public async dialogOpenHandler(): Promise<void> {
    this.clearForm();
  }

  private async save(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      const payload = new EditCompanyData();
      payload.name = this.form.name;
      payload.email = this.form.email;
      payload.id = this.company.getId();

      await this.companiesModule.Edit(payload);
    } else {
      throw new Error('Validation error');
    }
  }
}
